import { useState } from 'react';
import MapView from './MapView';

// This component simulates the API response and tests our map integration
const MapTest = () => {
  // Simulate the API response format
  const [apiResponse, setApiResponse] = useState({
    results: {
      rows: [
        { "Location Name": "San Francisco", "Latitude": "37.7749", "Longitude": "-122.4194" },
        { "Location Name": "New York", "Latitude": "40.7128", "Longitude": "-74.0060" },
        { "Location Name": "Chicago", "Latitude": "41.8781", "Longitude": "-87.6298" },
        { "Location Name": "Los Angeles", "Latitude": "34.0522", "Longitude": "-118.2437" },
        { "Location Name": "Miami", "Latitude": "25.7617", "Longitude": "-80.1918" }
      ]
    },
    interpretation: {
      suggestedChart: "map",
      map: {
        nameColumn: "Location Name",
        nameLabel: "Location Name",
        latitudeColumn: "Latitude",
        longitudeColumn: "Longitude"
      }
    }
  });

  // Process the API response to create map data
  const processMapData = () => {
    const { nameColumn, latitudeColumn, longitudeColumn } = apiResponse.interpretation.map;
    const rows = apiResponse.results.rows;
    
    if (!rows || !rows.length) return null;
    
    // Create map data format
    const mapData = {
      markers: rows.map(item => ({
        lat: parseFloat(item[latitudeColumn]),
        lon: parseFloat(item[longitudeColumn]),
        name: item[nameColumn] || 'Location',
        color: 'blue'
      })).filter(marker => 
        !isNaN(marker.lat) && !isNaN(marker.lon)
      )
    };
    
    // If we have markers, set the center to the first marker
    if (mapData.markers.length > 0) {
      mapData.center = [mapData.markers[0].lat, mapData.markers[0].lon];
      
      // Auto-adjust zoom based on number of markers
      if (mapData.markers.length > 100) mapData.zoom = 10;
      else if (mapData.markers.length > 50) mapData.zoom = 11;
      else if (mapData.markers.length > 10) mapData.zoom = 12;
      else mapData.zoom = 13;
    }
    
    return mapData;
  };

  const mapData = processMapData();

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Map Test (API Response Simulation)</h2>
      
      <div className="mb-4">
        <div className="bg-blue-50 p-4 rounded-lg mb-4">
          <h3 className="text-lg font-semibold mb-2">Simulated API Response:</h3>
          <pre className="text-xs overflow-auto max-h-60 bg-white p-2 rounded">
            {JSON.stringify(apiResponse, null, 2)}
          </pre>
        </div>
        
        <div className="bg-green-50 p-4 rounded-lg mb-4">
          <h3 className="text-lg font-semibold mb-2">Processed Map Data:</h3>
          <pre className="text-xs overflow-auto max-h-60 bg-white p-2 rounded">
            {JSON.stringify(mapData, null, 2)}
          </pre>
        </div>
      </div>
      
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Map Visualization:</h3>
        <MapView data={mapData} />
      </div>
      
      <div className="mt-4">
        <button
          onClick={() => {
            // Add a random location to test dynamic updates
            const newLocation = {
              "Location Name": "Random Location",
              "Latitude": (Math.random() * 10 + 30).toFixed(4),
              "Longitude": (Math.random() * 40 - 100).toFixed(4)
            };
            
            setApiResponse(prev => ({
              ...prev,
              results: {
                ...prev.results,
                rows: [...prev.results.rows, newLocation]
              }
            }));
          }}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Add Random Location
        </button>
      </div>
    </div>
  );
};

export default MapTest; 